import { IconButton as MuiIconButton, type IconButtonProps as MuiIconButtonProps } from "@mui/material";

export type IconButtonProps = MuiIconButtonProps;
export const IconButton = MuiIconButton;
